module.exports = __webpack_public_path__ + "img/last-point.a6f9dd2b.png";